// Centred shell for auth pages — /signin, /signup, /accept-invite,
// /onboarding/create-org. Brand wordmark above a single card.

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Brand } from './Brand';
import { Card, CardBody } from './Card';

export function AuthShell({
  children,
  brandSize = 'lg',
  cardPadding = 'lg',
}: {
  children: ReactNode;
  brandSize?: 'md' | 'lg';
  cardPadding?: 'md' | 'lg';
}) {
  return (
    <div className="ds-auth-shell">
      <div className="ds-auth-shell__inner">
        <div className="ds-auth-shell__brand">
          {/* Brand wordmark links to /welcome — gives signed-out visitors a
             route to the dictionary entry / about page. */}
          <Link to="/welcome" style={{ color: 'inherit', textDecoration: 'none' }}>
            <Brand size={brandSize} />
          </Link>
        </div>
        <Card elevated>
          <CardBody size={cardPadding}>{children}</CardBody>
        </Card>
      </div>
    </div>
  );
}
